import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { Formik, Field } from "formik";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../Style/CreateTask.css";
import "../../Style/NewCustomer.css";
import MainSidebar from "../Mainsidebar";
import UserNavbar from "../UserNavbar";
import UserFooter from "../UserFooter";
import { path_url } from "../../Config/config";
import { useParams } from "react-router-dom";
import defaultAvatar from "../../Images/default-avatar.svg";
import bb3 from "../../Images/bb3.jpg";
import { Avatar } from "@mui/material";
import ta from "date-fns/esm/locale/ta/index.js";
import CustomerDetails from "./CustomerDetails";
import Data_Table from "./Data_Table";
import SpeechToText from "../../AI/SpeechToText";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faCloudUploadAlt,
} from "@fortawesome/free-solid-svg-icons";

const customerSchema = Yup.object().shape({
  duedate: Yup.string().required("Required"),
  subject: Yup.string().required("Required"),
  createdby: Yup.string().required("Required"),
  lasmodifiedby: Yup.string().required("Required"),
  lastmodifieddate: Yup.string().required("Required"),
  lastmodifieddate: Yup.string().required("Required"),
  creationdate: Yup.string().required("Required"),
  duedate: Yup.string().required("Required"),
});
export default function TaskDetailsParent() {
  const [showComponent, setShowComponent] = useState(false);
  const [hamburger, sethamburger] = useState(false);
  const [isRightMenu, setisRightMenu] = useState(false);
  const [isSearchShow, setIsSearchShow] = useState(false);
  const [fullScreen, setFullScreen] = useState(true);
  // const [profile, setProfile] = useState([]);
  const [initialValues, setInitialValues] = useState({
    id: "",
    idType: "",
    duedate: "",
    subject: "",
    notes: "",
    asignedto: "",
    priority: "",
    status: "",
    createdby: "",
    lasmodifiedby: "",
    lastmodifieddate: "",
    creationdate: "",
    duedate: "",
  });

  const handleToggle = () => {
    setShowComponent(!showComponent);
  };
  const { id, index } = useParams();

  const handleScreenEnter = () => {
    setFullScreen(false);
    document.body.requestFullscreen();
  };
  const handleScreenExit = () => {
    setFullScreen(true);
    document.exitFullscreen();
  };
  const handelShow = () => setIsSearchShow(!isSearchShow);
  const handelRightMenuShow = () => setisRightMenu(!isRightMenu);
  const handleclickonbutton = (hamburger) => {
    if (document.documentElement.clientWidth <= 800)
      return { width: "100%", left: "0rem" };
    else
      return {
        width: !hamburger && "-webkit-fill-available",
        left: !hamburger && "3.7rem",
      };
  };
  const handleclickonbutton1 = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) {
      return { display: hamburger && "none" };
    }
  };

  const options = [
    { value: "option1", label: "Option 1" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];

  const Priority = [
    { value: "High" },
    { value: "Medium" },
    { value: "Low" },
    { value: "Critical" },
    { value: "Normal" },
    { value: "Emergency" },
    { value: "Deferred" },
  ];

  const Enum = [
    { value: "Open" },
    { value: "InProgress" },
    { value: "Pending" },
    { value: "Completed" },
    { value: "Canceled" },
    { value: "Deferred" },
    { value: "WaitingforCustomer" },
    { value: "WaitingforInternalReview" },
    { value: "Reassigned" },
    { value: "OnHold" },
    { value: "Overdue" },
    { value: "Scheduled" },
    { value: "NeedsMoreInformation" },
    { value: "Escalated" },
    { value: "Closed" },
    { value: "NotApplicable" },
  ];

  const [commentText, setCommentText] = useState("");
  const [usercid, SetUsercid] = useState("");
  const [comments, setComments] = useState([]);
  const [taskAttachments, setTaskAttachments] = useState([]);
  const taskId = id;
  const handleSave = async () => {
    const token = localStorage.getItem("accessToken");
    const adminId = localStorage.getItem("adminId"); // adminId is for useradminid and usercid
    // taskId should be fetched separately!

    if (!token || !adminId || !taskId) {
      toast.error("Missing required information (token/adminId/taskId).");
      return;
    }

    const requestBody = {
      taskId: taskId,
      useradminid: adminId,
      usercid: usercid,
      comment: commentText,
    };

    try {
      const response = await axios.post(
        `${path_url}/taskcomment`, // Make sure /taskcomment is the correct endpoint
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.status === 200 || response.data.statusCodeValue === 200) {
        toast.success("Comment saved successfully!");
        setCommentText(""); // Clear textarea
        fetchComments(); // Refresh comments
      } else {
        toast.error(response.data?.body || "Failed to save comment.");
      }
    } catch (error) {
      console.error("Error while saving comment:", error);
      toast.error(
        "Failed to save comment: " +
          (error.response?.data?.message || "Unknown error"),
      );
    }
  };

  const handleCancel = () => {
    setCommentText("");
  };

  const fetchComments = async () => {
    const token = localStorage.getItem("accessToken");

    if (!taskId) {
      toast.error("Task ID is missing to fetch comments.");
      return;
    }

    try {
      const response = await axios.get(`${path_url}/task/all/${taskId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const taskDetails = response.data.body.task;
      SetUsercid(taskDetails.usercid);
      // Determine which ID exists
      let idType = "";
      let idValue = "";

      if (taskDetails.vendorid) {
        idType = "Vendor";
        idValue = taskDetails.vendorid;
      } else if (taskDetails.customerid) {
        idType = "Customer";
        idValue = taskDetails.customerid;
      } else if (taskDetails.leadid) {
        idType = "Lead";
        idValue = taskDetails.leadid;
      }
      const formattedLastModifiedDate = taskDetails.lastModifiedDate
        ? new Date(taskDetails.lastModifiedDate).toISOString().split("T")[0]
        : "";

      const formattedCreationDate = taskDetails.creationDate
        ? new Date(taskDetails.creationDate).toISOString().split("T")[0]
        : "";

      const formattedDueDate = taskDetails.duedate
        ? new Date(taskDetails.duedate).toISOString().split("T")[0]
        : "";

      // Update initial values
      setInitialValues((prevValues) => ({
        ...prevValues,
        id: idValue,
        idType: idType,
        subject: taskDetails.subject || "",
        notes: taskDetails.notes || "",
        asignedto: taskDetails.asignedto || "",
        priority: taskDetails.priority || "",
        status: taskDetails.status || "",
        createdby: taskDetails.createdBy || "",
        lasmodifiedby: taskDetails.lastModifiedBy || "",
        lastmodifieddate: formattedLastModifiedDate,
        creationdate: formattedCreationDate,
        duedate: formattedDueDate,
      }));

      if (response.status === 200 || response.data.statusCodeValue === 200) {
        const commentsData = response.data.body.taskComments || [];
        const taskAttachmentsData = response.data.body.taskAttachments || [];

        setTaskAttachments(taskAttachmentsData);
        setComments(commentsData);
      } else {
        toast.error("Failed to fetch comments.");
      }
    } catch (error) {
      console.error("Error fetching comments:", error);
      toast.error(
        "Failed to fetch comments: " +
          (error.response?.data?.message || "Unknown error"),
      );
    }
  };
  const fetchTaskAttachments = async () => {
    const token = localStorage.getItem("accessToken");

    if (!taskId) {
      toast.error("Task ID is missing to fetch attachments.");
      return;
    }

    try {
      const response = await axios.get(`${path_url}/task/all/${taskId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200 || response.data.statusCodeValue === 200) {
        const taskAttachmentsData = response.data.body.taskAttachments || [];
        setTaskAttachments(taskAttachmentsData);
      } else {
        toast.error("Failed to fetch attachments.");
      }
    } catch (error) {
      console.error("Error fetching attachements:", error);
      toast.error(
        "Failed to fetch attachements: " +
          (error.response?.data?.message || "Unknown error"),
      );
    }
  };

  // Fetch comments initially
  useEffect(() => {
    fetchComments();
  }, []);

  // edit and delete comment in activity

  const [editingCommentId, setEditingCommentId] = useState();
  const [editingCommentText, setEditingCommentText] = useState("");
  const [editingCommentData, setEditingCommentData] = useState(null); // NEW: store full comment data

  const handleEditClick = (comment) => {
    setEditingCommentId(comment.id);
    setEditingCommentText(comment.comment);
    setEditingCommentData(comment); // store full comment for update
  };

  const handleUpdateComment = async () => {
    if (!editingCommentId || !editingCommentText.trim()) {
      toast.error("Comment cannot be empty!");
      return;
    }

    try {
      const token = localStorage.getItem("accessToken");
      if (!token) {
        toast.error("User is not authenticated.");
        return;
      }

      const updatedCommentData = {
        id: editingCommentData.id,
        taskId: editingCommentData.taskId,
        useradminid: editingCommentData.useradminid,
        usercid: editingCommentData.usercid,
        createdBy: editingCommentData.createdBy,
        creationDate: editingCommentData.creationDate,
        lastModifiedBy: localStorage.getItem("name") || "system", // or fetch proper user
        lastModifiedDate: new Date().toISOString(),
        comment: editingCommentText,
      };

      const response = await axios.put(
        `${path_url}/taskcomment/comment/${editingCommentId}`,
        updatedCommentData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.status === 200) {
        toast.success("Comment updated successfully!");
        setEditingCommentId(null);
        setEditingCommentText("");
        setEditingCommentData(null);
        fetchComments(); // refresh list
      }
    } catch (error) {
      console.error("Error updating comment:", error);
      toast.error("Failed to update comment.");
    }
  };

  const handleDeleteComment = async (id) => {
    try {
      const token = localStorage.getItem("accessToken");

      await axios.delete(`${path_url}/taskcomment/comment/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      toast.success("Comment deleted successfully!");
      fetchComments();
    } catch (error) {
      console.error("Error deleting comment:", error);
      toast.error("Failed to delete comment.");
    }
  };

  //attachment and comment
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedComment, setSelectedComment] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showUploadModal, setShowUploadModal] = useState(false);

  const [type, setType] = useState("task");

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file || !type) {
      alert("Please fill all fields.");
      return;
    }
    const formData = new FormData();
    formData.append("file", file);

    try {
      const token = localStorage.getItem("accessToken");
      const response = await axios.post(
        `${path_url}/taskattachment/task/upload/${taskId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );
      fetchTaskAttachments();
      setFile(null);

      toast.success("File uploaded successfully!");
    } catch (error) {
      console.error("Error uploading file:", error);
      toast.error("Failed to upload file.");
    }
  };

  const [isActivityOpen, setIsActivityOpen] = useState(true);

  const toggleActivity = () => {
    setIsActivityOpen((prevState) => !prevState);
  };

  const handleModalUpload = async () => {
    if (!selectedFile || !selectedComment) {
      toast.error("Please select a file.");
      return;
    }

    const currentUserId = localStorage.getItem("adminId");
    if (selectedComment.usercid !== currentUserId) {
      toast.error("You are not authorized to upload for this comment.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("commentId", selectedComment.id);

    try {
      const token = localStorage.getItem("accessToken");
      const response = await axios.post(
        `${path_url}/taskattachment/comment/upload/${selectedComment.id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (response.status === 200) {
        toast.success("File uploaded successfully!");
        fetchComments();
        setShowUploadModal(false);
        setSelectedFile(null);
      } else {
        toast.error("Failed to upload file.");
      }
    } catch (error) {
      console.error(error);
      toast.error("File upload failed.");
    }
  };

  return (
    <>
      {showUploadModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            className="modal-dialog modal-sm"
            style={{ maxWidth: "400px", width: "100%" }}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Upload File</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => {
                    setShowUploadModal(false);
                    setSelectedFile(null);
                  }}
                >
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => setSelectedFile(e.target.files[0])}
                />
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowUploadModal(false);
                    setSelectedFile(null);
                  }}
                >
                  Cancel
                </button>
                <button className="btn btn-primary" onClick={handleModalUpload}>
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="con1 d-flex">
        <div className="subcon1" style={handleclickonbutton1(hamburger)}>
          <MainSidebar hamburger={hamburger} sethamburger={sethamburger} />
        </div>
        <div className="subcon2" style={handleclickonbutton(hamburger)}>
          <UserNavbar
            hamburger={hamburger}
            sethamburger={sethamburger}
            handelRightMenuShow={handelRightMenuShow}
            handelShow={handelShow}
            isSearchShow={isSearchShow}
            handleScreenEnter={handleScreenEnter}
            handleScreenExit={handleScreenExit}
            fullScreen={fullScreen}
          />

          <div className="mt-2">
            <Formik
              enableReinitialize
              initialValues={initialValues}
              validationSchema={customerSchema}
              onSubmit={async (values) => {
                try {
                  const token = localStorage.getItem("accessToken");
                  const adminId = localStorage.getItem("adminId"); // Retrieve useradminid
                  const response = await axios.post(
                    `${path_url}/task`,
                    { ...values, useradminid: adminId },
                    {
                      headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                      },
                    },
                  );
                  if (response.data.statusCodeValue === 200) {
                    // navigate("");

                    // onTaskCreated(response.data.body); // Update the task list in the parent component
                    // setTimeout(() => {
                    //   window.location.reload(); // Refresh the page to show the new task
                    // }, 1000);

                    toast.success("form submitted successfully");
                  } else {
                    toast.error(response.data.body);
                  }
                } catch (errors) {}
              }}
            >
              {(formik) => (
                <form action="" onSubmit={formik.handleSubmit}>
                  <fieldset>
                    <div className="col-12 d-flex justify-content-center">
                      <div className="bg-white col-11 cont">
                        <div
                          style={{ boxShadow: "0 1px 1px lightgray" }}
                          className="d-flex flexDir-column mt-2 col-12 elevation-2 mb-2 justify-content-between"
                        >
                          <p
                            style={{ color: "gray" }}
                            className=" p-1 m-0 custom-font-size"
                          >
                            <strong>Task Details</strong>
                          </p>
                          <div className="d-flex input-with-speech">
                            <input
                              id="voice-input-box"
                              type="text"
                              placeholder="Voice input displayed here..."
                              disabled
                            ></input>
                            <SpeechToText inputId="voice-input-box" />
                          </div>
                        </div>
                        {/* <div className="border col-11 mt-1 ml-5 "></div> */}

                        <div className="d-flex flex-wrap">
                          <div className="col-12 col-md-6 pl-0 pr-0">
                            <div className="col-12 col-sm-12 d-flex  mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-right"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Subject</strong>
                                  <sup
                                    style={{
                                      color: "red",
                                      top: 0,
                                      fontSize: 15,
                                      lineHeight: 0,
                                      position: "relative",
                                      verticalAlign: "baseline",
                                    }}
                                  >
                                    *
                                  </sup>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="Subject"
                                  name="subject"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.subject}
                                />
                                {formik.touched.subject &&
                                  formik.errors.subject && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.subject}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex  mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-right"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Due Date:</strong>
                                  <sup
                                    style={{
                                      color: "red",
                                      top: 0,
                                      fontSize: 15,
                                      lineHeight: 0,
                                      position: "relative",
                                      verticalAlign: "baseline",
                                    }}
                                  >
                                    *
                                  </sup>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 d-flex  ">
                                <div
                                  className="col-12 m-0"
                                  style={{
                                    paddingLeft: "2px",
                                    paddingRight: "0px",
                                  }}
                                >
                                  <div className="p-0 m-0 w-100  forms ">
                                    <input
                                      className="input-field date "
                                      type="date"
                                      placeholder=""
                                      name="duedate"
                                      value={formik.values.duedate}
                                      onChange={formik.handleChange}
                                    />
                                  </div>
                                  <div className="p-0 m-0 d-flex justify-content-center">
                                    {formik.touched.duedate &&
                                      formik.errors.duedate && (
                                        <span style={{ color: "red" }}>
                                          {formik.errors.duedate}
                                        </span>
                                      )}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-right"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Priority</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8">
                                <Field
                                  as="select"
                                  name="priority"
                                  id="priority"
                                  className="selectBox custom-select "
                                >
                                  <option value="Active">Select</option>
                                  {Priority.map((option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.value}
                                    </option>
                                  ))}
                                </Field>
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 d-flex  mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-right"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Status</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8">
                                <Field
                                  as="select"
                                  name="status"
                                  id="status"
                                  className="selectBox custom-select "
                                >
                                  <option value="Indiamart">Open</option>
                                  {Enum.map((option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.value}
                                    </option>
                                  ))}
                                </Field>
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex  mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-right"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Created By</strong>
                                  <sup
                                    style={{
                                      color: "red",
                                      top: 0,
                                      fontSize: 15,
                                      lineHeight: 0,
                                      position: "relative",
                                      verticalAlign: "baseline",
                                    }}
                                  >
                                    *
                                  </sup>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="Created By"
                                  name="createdby"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.createdby}
                                />
                                {formik.touched.createdby &&
                                  formik.errors.createdby && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.createdby}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex  mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-right"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Last Modified By</strong>
                                  <sup
                                    style={{
                                      color: "red",
                                      top: 0,
                                      fontSize: 15,
                                      lineHeight: 0,
                                      position: "relative",
                                      verticalAlign: "baseline",
                                    }}
                                  >
                                    *
                                  </sup>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="Last Modified By"
                                  name="lasmodifiedby"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.lasmodifiedby}
                                />
                                {formik.touched.lasmodifiedby &&
                                  formik.errors.lasmodifiedby && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.lasmodifiedby}
                                    </span>
                                  )}
                              </div>
                            </div>
                            {/* <div className="border col-12 ml-1 mb-3"></div> */}
                          </div>

                          <div className="col-12 col-md-6 pl-0 pr-0">
                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg ">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-right"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Assigned To </strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8">
                                <Field
                                  as="select"
                                  name="assignedto"
                                  id="assignedto"
                                  className="selectBox custom-select "
                                >
                                  <option value="Mobile">John Red</option>
                                  {options.map((option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  ))}
                                </Field>
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex  mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-right"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Created Date:</strong>
                                  <sup
                                    style={{
                                      color: "red",
                                      top: 0,
                                      fontSize: 15,
                                      lineHeight: 0,
                                      position: "relative",
                                      verticalAlign: "baseline",
                                    }}
                                  >
                                    *
                                  </sup>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 d-flex  ">
                                <div
                                  className="col-12 m-0"
                                  style={{
                                    paddingLeft: "2px",
                                    paddingRight: "0px",
                                  }}
                                >
                                  <div className="p-0 m-0 w-100  forms ">
                                    <input
                                      className="input-field date "
                                      type="date"
                                      placeholder=""
                                      name="creationdate"
                                      value={formik.values.creationdate}
                                      onChange={formik.handleChange}
                                    />
                                  </div>
                                  <div className="p-0 m-0 d-flex justify-content-center">
                                    {formik.touched.creationdate &&
                                      formik.errors.creationdate && (
                                        <span style={{ color: "red" }}>
                                          {formik.errors.creationdate}
                                        </span>
                                      )}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex  mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Last Modified Date:</strong>
                                  <sup
                                    style={{
                                      color: "red",
                                      top: 0,
                                      fontSize: 15,
                                      lineHeight: 0,
                                      position: "relative",
                                      verticalAlign: "baseline",
                                    }}
                                  >
                                    *
                                  </sup>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 d-flex  ">
                                <div
                                  className="col-12 m-0"
                                  style={{
                                    paddingLeft: "2px",
                                    paddingRight: "0px",
                                  }}
                                >
                                  <div className="p-0 m-0 w-100  forms ">
                                    <input
                                      className="input-field date "
                                      type="date"
                                      placeholder=""
                                      name="lastmodifieddate"
                                      value={formik.values.lastmodifieddate}
                                      onChange={formik.handleChange}
                                    />
                                  </div>
                                  <div className="p-0 m-0 d-flex justify-content-center">
                                    {formik.touched.lastmodifieddate &&
                                      formik.errors.lastmodifieddate && (
                                        <span style={{ color: "red" }}>
                                          {formik.errors.lastmodifieddate}
                                        </span>
                                      )}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className=" col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-right"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Notes</strong>
                                </label>
                              </div>

                              <div className="col-12 col-sm-8  forms">
                                <textarea
                                  type="text"
                                  id="notes"
                                  name="notes"
                                  rows={5}
                                  placeholder="Notes"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.notes}
                                />
                              </div>
                            </div>

                            {/* <div className="border col-12 ml-1 mb-3"></div> */}
                          </div>
                        </div>
                        <div className="col-12 col-sm-12 d-flex mb-2">
                          <div className="col-12 col-sm-6 d-flex justify-content-center p-2">
                            <button className="btn btn-light border rounded border-gray">
                              Cancel
                            </button>
                          </div>
                          <div className="col-12 col-sm-6 d-flex justify-content-center p-2">
                            <button
                              type="submit"
                              className="btn border rounded border-gray btn-info "
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </form>
              )}
            </Formik>

            {/* Attachment section */}
            <div className="col-12 d-flex  justify-content-center mb-4">
              <div className="bg-white col-11 mt-3 cont">
                <div className="container my-4">
                  <div className="card-body">
                    <div className="d-flex border-bottom justify-content-between align-items-center mb-4">
                      <div className="h5 text-dark font-weight-bold">
                        Attachments
                      </div>
                      <button
                        className="btn btn-link text-dark font-weight-bold"
                        onClick={toggleDropdown}
                      >
                        <FontAwesomeIcon icon={faChevronDown} />
                      </button>
                    </div>

                    <div
                      className={` p-4 rounded-lg ${
                        isDropdownOpen ? "" : "d-none"
                      }`}
                    >
                      <div className="mb-3  w-100">
                        <label
                          htmlFor="fileUpload"
                          className="form-label w-100 border border-secondary rounded text-center py-4 px-2 bg-light d-flex flex-column justify-content-center align-items-center"
                          style={{ cursor: "pointer" }}
                          onDragOver={(e) => e.preventDefault()}
                          onDrop={(e) => {
                            e.preventDefault();
                            if (e.dataTransfer.files.length > 0) {
                              setFile(e.dataTransfer.files[0]);
                            }
                          }}
                        >
                          <div className="text-muted ">
                            <strong>Drop files to attach</strong> or{" "}
                            <u className="text-primary">browse</u>
                          </div>
                          <input
                            id="fileUpload"
                            type="file"
                            className="d-none"
                            onChange={handleFileChange}
                          />
                        </label>

                        {file && (
                          <div className="mt-3 d-flex justify-content-between align-items-center border p-2 rounded bg-white">
                            <div
                              className="text-truncate text-primary"
                              style={{ maxWidth: "70%" }}
                            >
                              📎 {file.name}
                            </div>
                            <button
                              className="btn btn-sm btn-success"
                              onClick={handleUpload}
                            >
                              Upload
                            </button>
                          </div>
                        )}
                      </div>

                      <div
                        className="overflow-auto pr-2"
                        style={{ maxHeight: "400px", scrollBehavior: "smooth" }}
                      >
                        <ul className="list-group list-group-flush">
                          {taskAttachments.map((file, index) => (
                            <li
                              className="list-group-item d-flex justify-content-between align-items-center px-0"
                              key={index}
                            >
                              <span
                                className="text-primary text-truncate"
                                style={{ maxWidth: "70%" }}
                              >
                                {file.filename}
                              </span>
                              <span className="text-muted small">
                                {`${new Date(
                                  file.creationDate,
                                ).toLocaleString()}`}
                              </span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* comment section */}

          <div className="col-12 d-flex justify-content-center mb-4">
            <div className="bg-white col-11 mt-3 cont">
              <div className="container mt-4">
                <div className="border-bottom pb-2 mb-4 d-flex justify-content-between">
                  <h2 className="h5 font-weight-bold">Activity</h2>
                  <button
                    className="btn btn-link text-dark font-weight-bold"
                    onClick={toggleActivity}
                  >
                    <FontAwesomeIcon icon={faChevronDown} />
                  </button>
                </div>

                {isActivityOpen && (
                  <div
                    className="overflow-auto pr-2"
                    style={{ maxHeight: "400px", scrollBehavior: "smooth" }}
                  >
                    {comments.length === 0 ? (
                      <div className="text-center text-muted font-italic">
                        No comments available.
                      </div>
                    ) : (
                      comments.map((comment, index) => (
                        <div
                          className="d-flex align-items-start mb-4"
                          key={index}
                        >
                          <div className="ml-3 w-100">
                            <div className="d-flex align-items-center justify-content-between">
                              <div>
                                <span className="font-weight-bold text-primary">
                                  {localStorage.getItem("name")}
                                </span>
                                <span className="text-muted small ml-2">
                                  {`added a comment - ${new Date(
                                    comment.creationDate,
                                  ).toLocaleString()}`}
                                </span>
                                {comment.edited && (
                                  <span className="text-muted small italic ml-2">
                                    - edited
                                  </span>
                                )}
                              </div>
                            </div>

                            {editingCommentId === comment.id ? (
                              <>
                                <textarea
                                  value={editingCommentText}
                                  onChange={(e) =>
                                    setEditingCommentText(e.target.value)
                                  }
                                  className="form-control mt-2 mb-2"
                                  rows="2"
                                />
                                <div className="d-flex gap-2">
                                  <button
                                    className="btn btn-sm btn-success"
                                    onClick={handleUpdateComment}
                                  >
                                    Save
                                  </button>
                                  <button
                                    className="btn btn-sm btn-secondary"
                                    onClick={() => {
                                      setEditingCommentId(null);
                                      setEditingCommentText("");
                                      setEditingCommentData(null);
                                    }}
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </>
                            ) : (
                              <>
                                <p className="mt-1 font-weight-bold text-black">
                                  {comment.comment}
                                </p>
                                <div className="d-flex align-items-center text-muted small mt-">
                                  <button
                                    className="btn btn-link p-3"
                                    onClick={() => handleEditClick(comment)}
                                  >
                                    Edit
                                  </button>
                                  <button
                                    className="btn btn-link p-3 text-danger"
                                    onClick={() =>
                                      handleDeleteComment(comment.id)
                                    }
                                  >
                                    Delete
                                  </button>
                                  <button
                                    className="btn btn-link p-3 text-success"
                                    onClick={() => {
                                      setSelectedComment(comment);
                                      setShowUploadModal(true);
                                    }}
                                  >
                                    Upload
                                  </button>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-12 d-flex justify-content-center">
            <div className="bg-white col-11 mt-3 cont">
              <div className="d-flex justify-content-center">
                <div>
                  <p
                    style={{ color: "gray" }}
                    className="p-1 my-3 custom-font-size"
                  >
                    <strong>Comments</strong>
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-12 pl-0 pr-0">
                <div className="col-12 col-sm-12 d-flex mb-2">
                  <div className="col-12 col-sm-12 forms">
                    <textarea
                      type="text"
                      id="notes"
                      name="notes"
                      rows={3}
                      placeholder="Write your comment here..."
                      value={commentText}
                      onChange={(e) => setCommentText(e.target.value)}
                    />
                  </div>
                </div>

                <div className="d-flex mb-2">
                  <div className="col-sm-6 d-flex justify-content-center p-2">
                    <button
                      className="btn btn-sm btn-light border rounded border-gray"
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                  </div>
                  <div className="col-sm-6 d-flex justify-content-center p-2">
                    <button
                      type="button"
                      className="btn border rounded border-gray btn-info"
                      onClick={handleSave}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
        </div>
      </div>
    </>
  );
}
